import React from 'react';
import { Button } from 'antd';
import propTypes from 'prop-types';
import cn from 'classnames';
import { WithModal } from 'hocs/withModal';
import classes from './ButtonTempleView.module.scss';
import TemplateEditor from '../TemplateEditor/index';

const ViewFormModal = WithModal(TemplateEditor);

const ButtonView = ({ name, type, className, templateNo, active = true, scheme }) => {
  return (
    <ViewFormModal
      title={name}
      width={879}
      footer={null}
      scheme={scheme}
      triggerElement={
        <Button
          className={cn(classes.button, className, {
            [classes.inactive]: !active,
          })}
          type={type}>
          {`${name} ${templateNo ? `- ${templateNo}` : ''}`}
        </Button>
      }
    />
  );
};

ButtonView.propTypes = {
  className: propTypes.string,
  type: propTypes.oneOf(['primary', 'default', 'dashed', 'link', 'text', 'ghost']),
  name: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  id: propTypes.string,
  scheme: propTypes.string,
};

ButtonView.defaultProps = {
  type: 'link',
  className: '',
  scheme: '',
  id: '',
};

export default ButtonView;
